/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Goback1Inputs */

const en_btn_goback1 = /** @type {(inputs: Btn_Goback1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go back`)
};

/**
* | output |
* | --- |
* | "Go back" |
*
* @param {Btn_Goback1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_goback1 = /** @type {((inputs?: Btn_Goback1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Goback1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_goback1(inputs)
});
export { btn_goback1 as "btn_goBack" }